import type { NodeTypeDef, OutputChannel } from '../core/types';

/** The material channels a graph can drive, in the order the UI lists them. */
export const OUTPUT_CHANNELS: {
  value: OutputChannel;
  label: string;
  kind: 'grayscale' | 'color';
}[] = [
  { value: 'basecolor', label: 'Base Color', kind: 'color' },
  { value: 'normal', label: 'Normal', kind: 'color' },
  { value: 'roughness', label: 'Roughness', kind: 'grayscale' },
  { value: 'metallic', label: 'Metallic', kind: 'grayscale' },
  { value: 'height', label: 'Height', kind: 'grayscale' },
  { value: 'ao', label: 'Ambient Occlusion', kind: 'grayscale' },
  { value: 'emissive', label: 'Emissive', kind: 'color' },
  { value: 'opacity', label: 'Opacity', kind: 'grayscale' },
];

export const outputNodes: NodeTypeDef[] = [
  {
    id: 'output.channel',
    label: 'Output',
    category: 'output',
    description: 'Route a result into one of the material channels.',
    guidance:
      'The terminal node. Whatever reaches an Output drives that channel in the 3D preview and in the exported texture set. A graph needs at least a Base Color output to render as a material.',
    keywords: ['export', 'result', 'material', 'basecolor', 'normal', 'roughness', 'final'],
    inputs: [{ name: 'input', label: 'Input', kind: 'color' }],
    output: 'passthrough',
    passthroughFrom: 'input',
    params: [
      {
        name: 'channel',
        label: 'Channel',
        type: 'enum',
        default: 'basecolor',
        options: OUTPUT_CHANNELS.map((c) => ({ value: c.value, label: c.label })),
      },
    ],
    // Passthrough by design: the node's job is routing, not transformation.
    // Keeping it a real render pass means its thumbnail behaves like every other node's.
    shader: /* glsl */ `
      vec4 texdir(vec2 uv) { return in0(uv); }
    `,
  },
];
